import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { EventEditor } from "../../events-screen/event-page-models/event-editor";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { UserManagementService } from "../../../_services/user-management.service";
import { AppUserFullModel } from "../user-management-models/app-user.model";
import { UserManagementFormComponent } from "../user-management-form/user-management-form.component";
import { EventValidationService } from "../../../_services/eventsServices/eventValidation.service";
import { UserPostModel } from "../user-management-models/user-post-model";

@Component({
  selector: "user-management-activity-form",
  templateUrl: "./user-management-activity-form.html",
  styleUrls: ["./user-management-activity-form.scss"],
})
export class UserManagementActivityForm
  extends UserManagementFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public layerCollectionGlobalData: any;
  public showPasswordManagement: boolean = false;
  public dataWasLoaded: boolean = false;
  public readonly initialFormValuesOnEdit = {
    israeliId: "",
    email: "",
    phoneNumber: "",
    userName: "",
  };
  public UserManagementFormComponent = UserManagementFormComponent;
  @ViewChild("formTabSet") public formTabSet: NgbTabset;
  @Input("modalEventId") public modalUserId: "new" | string;
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();

  public userEditPersonalDetailsForm: FormGroup = new FormGroup({
    israeliId: new FormControl(""),
    email: new FormControl(""),
    firstName: new FormControl("", {
      validators: [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(20),
      ],
    }),
    lastName: new FormControl("", { validators: [Validators.required] }),
    phoneNumber: new FormControl(""),
    userName: new FormControl(""), // new FormControl("", {validators: [Validators.required], updateOn: "blur"}),
  });
  public userEditSystemPrivilegesForm: FormGroup = new FormGroup({
    isActive: new FormControl(""),
    isDeleted: new FormControl(""),
    privilegeType: new FormControl(""),
    viewOnly: new FormControl(""),
    cashCollection: new FormControl(""),
    creditCollection: new FormControl(""),
    refundPassWord: new FormControl(""),
  });
  public activityFieldsForm: FormGroup = new FormGroup({
    has_extra_unseen_permission: new FormControl(""),
    userFormLayers: new FormControl([]),
    userSelectedOrgans: new FormControl([]),
    availableOrgans: new FormControl([]),
  });

  public userManagementMegaForm: FormGroup = new FormGroup({
    personalDetails: this.userEditPersonalDetailsForm,
    systemPrivileges: this.userEditSystemPrivilegesForm,
    activityFields: this.activityFieldsForm,
  });
  public isNewUser: boolean = true;
  public disableSave: boolean = false;
  public specificEventName: string = "ארוע";
  public translations$: Observable<ITranslations>;
  public userName: string = "";

  constructor(
    protected translationService: TranslationService,
    protected eventsService: EventsService,
    protected dataService: DataService,
    protected userManagementService: UserManagementService,
    protected authenticationService: AuthenticationService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected modalService: NgbModal,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super(
      translationService,
      eventsService,
      dataService,
      userManagementService,
      authenticationService,
      activatedRoute,
      router,
      modalService,
      changeDetectorRef
    );
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.initPage().then();
    this.initUserEditForm(this.modalUserId).then();

    this.userManagementMegaForm.valueChanges.subscribe((value) => {});
  }

  public ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  public ngOnDestroy(): void {}

  public async buildMegaFormObject() {
    const allParentQuestions = await new Promise((resolve, reject) => {
      this.eventsService
        .getAllQuestions()
        .subscribe((questions) => resolve(questions));
    });
    const allPermittedUsers: EventEditor[] = (await new Promise(
      (resolve, reject) => {
        this.eventsService
          .getAllPermittedUsers()
          .subscribe((users) => resolve(users as EventEditor[]));
      }
    )) as EventEditor[];

    const megaFormData = JSON.parse(
      JSON.stringify(this.userManagementMegaForm.value)
    );

    megaFormData.parentEventParentQuestions = allParentQuestions;
    megaFormData.parentEventAllPermittedUsers = allPermittedUsers.filter(
      (u) => u.canEditEvent
    );
    return megaFormData;
  }

  public async submit() {
    const megaFormData = await this.buildMegaFormObject();

    const serializedMegaFormForPost =
      UserManagementService.serializeUserActivityFieldsDataToPostData(
        megaFormData
      );

    const validationErrors = this.validateMegaForm();
    if (validationErrors.length) {
      this.showValidationErrors(validationErrors);
      return;
    }
    let saveResponse;
    this.disableSave = true;

    saveResponse = await this.userManagementService.saveExistingUser(
      serializedMegaFormForPost as UserPostModel,
      this.modalUserId
    );

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    if (saveResponse.success) {
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "סיום",
        modalText: "שדות הפעילות של " + `${this.userName}` + " נשמרו בהצלחה",
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        this.closeParentEventModal();
      });
      return;
    } else {
      const isDisconnected =
        saveResponse.error && saveResponse.error.status === 401;

      const errorMessage =
        await EventValidationService.convertServer400ErrorsToReadableText(
          saveResponse.error
        );
      const modalText = isDisconnected
        ? "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש."
        : ` השמירה נכשלה. פרטים:   ${"\n" + errorMessage}`;
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "שגיאה",
        modalText,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        if (isDisconnected) {
          this.closeParentEventModal();
          setTimeout(() => this.router.navigate(["/login"]), 1000);
        }
      });
      this.disableSave = false;
    }
  }

  public async closeParentEventModal() {
    this.modalAction.emit("close");
  }

  protected async initUserEditForm(userId: string) {
    if (!userId && this.modalUserId) {
      userId = this.modalUserId;
    }

    this.isNewUser = false;
    const userData =
      await this.userManagementService.GetUserDataAndEditorDataForEdit(userId);

    // @ts-ignore
    this.patchFormValues(userData);

    if (!userData) {
      const modalRef: NgbModalRef = this.modalService.open(
        GenericModalComponent
      );
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "שגיאה",
        modalText: ` ${this.specificEventName} ${userId} לא קיים במערכת.  `,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {});
    }
    this.dataWasLoaded = true;
  }

  protected handleError(err: any) {
    const isDisconnected = err.status === 401;
    const noUserPermission = err.status === 400;
    let modalText = err.toString();
    if (noUserPermission) {
      modalText = `אין לך הרשאה מספקת לערוך את ה${this.specificEventName}   `;
    } else if (isDisconnected) {
      modalText = "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.";
    }

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {
      this.closeParentEventModal().then((r) => r);
      if (isDisconnected) {
        setTimeout(() => this.router.navigate(["/login"]), 1000);
      }
    });
  }

  protected showValidationErrors(validationErrors: string[]) {
    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText: `לשם שמירת ה${this.specificEventName}: ${validationErrors.join(
        ", "
      )}`,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {});
  }

  protected async initPage() {
    await super.initPage();
  }

  protected patchFormValues(userData: AppUserFullModel) {
    this.userName = `${userData.firstName} ${userData.lastName}`;
    this.activityFieldsForm.patchValue({
      userFormLayers: [],
      has_extra_unseen_permission: userData.has_extra_unseen_permission,
      userSelectedOrgans: userData.currentOrgans,
      availableOrgans: userData.availableOrgans,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-activity-form/user-management-activity-form.ts